import { render } from "./Register.vue?vue&type=template&id=fb71a40e&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=fb71a40e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fb71a40e"

export default script